import { SubjectStopForm, SubjectStopBootstrapResponse } from '@mark43/cad-api';

export function getSubjectDataFormDefaultValues({
    currentUserId,
    subjectDataQueryResponse,
}: {
    currentUserId: number;
    subjectDataQueryResponse: SubjectStopBootstrapResponse;
}): Partial<SubjectStopForm> {
    const defaultUserOption = subjectDataQueryResponse.subjectStopOptions.userOptions.find(
        (option) => option.value === currentUserId
    );

    return {
        userOption: defaultUserOption,
        stopDateUtc: subjectDataQueryResponse?.subjectStopForm?.eventCreatedDateUtc,
    };
}

export function getValidationError(message: string) {
    return {
        type: 'validation',
        message,
    };
}
